// extracted by mini-css-extract-plugin
export default {"paginator":"Paginator_paginator__tyta3","number":"Paginator_number__bEfPp","activeNumber":"Paginator_activeNumber__zgA1O"};